module.exports = __webpack_public_path__ + "static/media/deactivate.d7e1a927.svg";